import type { PagesMenu } from '@/types/pagesMenu';

export const menuCollector: PagesMenu[] = [
  {
    label: 'Menus',
    icon: 'pi pi-fw pi-home',
    items: [
      { label: 'Home', to: '/', name: 'Home' },
      { label: '1242', to: '/1242', name: 'Visualizar End. Merc.' },
    ],
  },
];
